import { Injectable } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { ViewAssetModalPage } from '../modals/view-asset-modal/view-asset-modal.page';
import { AssetManagementService } from './asset-management.service';
import { AlertService } from './alert.service';
import { AddOutcomeToSceneModalPage } from '../modals/add-outcome-to-scene-modal/add-outcome-to-scene-modal.page';
import { Scene } from '../models/Scene';
import { ApiVrEventService } from '../api-services/vr-event.api.service';
import { AssetTypeService } from './asset-type.service';
import { ApiAssetService } from '../api-services/asset.api.service';
import { VrEventTypeService } from './vr-event-type.service';
import { VrEventTriggerService } from './vr-event-trigger.service';
import { ViewOutcomeModalPage } from '../modals/view-outcome-modal/view-outcome-modal.page'
import { ValidationService } from './validation.service';
import { ViewAssetStorageModalPage } from '../modals/view-asset-storage-modal/view-asset-storage-modal.page';
import { ViewTermsAndPoliciesModalPage } from '../modals/view-terms-and-policies-modal/view-terms-and-policies-modal.page';
import { SceneSettingsModalPage } from '../modals/scene-settings-modal/scene-settings-modal.page';
import { ProjectOutcomeManagementPage } from '../modals/project-outcome-management/project-outcome-management.page';
import { HelpModalPage } from '../modals/help-modal/help-modal.page';
import { ProjectOutcomeRelationService } from './project-outcome-relation.service';
import { Outcome } from '../models/outcomes/Outcome';
import { OutcomeActionManagementModalPage } from '../modals/outcome-action-management-modal/outcome-action-management-modal.page';
import { OutcomeAction } from '../models/outcomes/OutcomeAction';
import { AssetInScene } from '../models/AssetInScene';
import { OutcomeActionService } from './outcome-action.service';
import { DeepCopyService } from './deep-copy.service';
import { ExportProjectWizardModalPage } from '../modals/export-project-wizard-modal/export-project-wizard-modal.page';
import { Project } from '../models/Project';
import { AddLearnerModalPage } from '../modals/add-learner-modal/add-learner-modal.page';
import { Learner } from '../models/Learner';
import { CustomerUsageService } from './customer-usage.service';
import { MessagesService } from './messages.service';
import { Router } from '@angular/router';
import { User } from '../models/User';
import { AddUserModalPage } from '../modals/add-user-modal/add-user-modal.page';
import { Customer } from '../models/Customer';
import { AddCustomerModalPage } from '../modals/add-customer-modal/add-customer-modal.page';
import { ManageCustomerUsageModalPageModule } from '../modals/manage-customer-usage-modal/manage-customer-usage-modal.module';
import { ManageCustomerUsageModalPage } from '../modals/manage-customer-usage-modal/manage-customer-usage-modal.page';
import { CryptoService } from './crypto.service';
import { StorageService } from './storageService.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private _isAddOutcomeModalOpen: boolean = false;
  private _isHelpModalOpen: boolean = false;
  private _isViewAssetModalOpen: boolean = false;
  private _isViewTermsAndConditionsModalOpen: boolean = false;
  private _isViewOutcomeModalOpen: boolean = false;
  private _isStorageModalOpen: boolean = false;
  private _isSceneOutcomeActionsModalOpen: boolean = false;
  private _isAssetOutcomeActionsModalOpen: boolean = false;
  private _isSceneSettingsModalOpen: boolean = false;
  private _isExportProjectWizardModalOpen: boolean = false;
  private _isProjectOutcomeManagementOpen: boolean = false;

  constructor(
    public alertController: AlertController,
    public assetManagementService: AssetManagementService,
    public customerUsageService: CustomerUsageService,
    public modalController: ModalController,
    public alertService: AlertService,
    public assetTypeService: AssetTypeService,
    public VrEventAPIService: ApiVrEventService,
    public assetAPIService: ApiAssetService,
    public VrEventTypeService: VrEventTypeService,
    public VrEventTriggerService: VrEventTriggerService,
    public validationService: ValidationService,
    public ProjectOutcomeRelationService: ProjectOutcomeRelationService,
    public outcomeActionService: OutcomeActionService,
    public deepCopyService: DeepCopyService,
    public messagesService: MessagesService,
    public router: Router,
    public cryptoService: CryptoService,
    public storageService: StorageService
  ) { }



  // reinitAssetEvent(sceneAssetRelation: SceneAssetRelation) {
  //   var entity = document.querySelector('#entity-' + sceneAssetRelation.sceneAssetRelationId);
  //   if (entity == null) {
  //     var entity = document.querySelector('#submit-button-entity-' + sceneAssetRelation.sceneAssetRelationId);
  //   }

  //   if (entity) {
  //     entity.removeAttribute('init-event');
  //     entity.setAttribute('init-event', sceneAssetRelation.sceneAssetRelationId);
  //   }
  // }

  async openAddLearnerModal(learner, isEditing) {
    if (learner == null) {
      learner = new Learner();
    }
    var modal = await this.modalController.create({
      component: AddLearnerModalPage,
      id: 'add-learner-modal',
      componentProps: {
        "isEditing": isEditing,
        "learner": learner
      }
    });

    modal.onDidDismiss().then(result => {

    });

    return await modal.present();
  }

  async openAddUserModal(user, isEditing) {
    if (user == null) {
      user = new User();
    }
    var modal = await this.modalController.create({
      component: AddUserModalPage,
      id: 'add-user-modal',
      componentProps: {
        "isEditing": isEditing,
        "user": user
      }
    });

    modal.onDidDismiss().then(result => {

    });

    return await modal.present();
  }

  async openAddCustomerModal(customer, isEditing) {
    if (customer == null) {
      customer = new Customer();
      customer.licenseType = "Trial";
      customer.blobStorageLocation = "UK";
      customer.dateFormat = "EU";
      customer.country = "United Kingdom";
      customer.expiryDate = new Date()
    }
    var modal = await this.modalController.create({
      component: AddCustomerModalPage,
      id: 'add-customer-modal',
      componentProps: {
        "isEditing": isEditing,
        "customer": customer
      }
    });

    modal.onDidDismiss().then(result => {

    });

    return await modal.present();
  }

  async openCustomerUsageModal(customer, customerUsage) {

    var modal = await this.modalController.create({
      component: ManageCustomerUsageModalPage,
      id: 'manage-customer-usage-modal',
      componentProps: {
        "customer": customer,
        "customerUsage": customerUsage
      }
    });

    modal.onDidDismiss().then(result => {

    });

    return await modal.present();
  }


  async openAddOutcomeToSceneModal(scene: Scene) {

    if (this._isAddOutcomeModalOpen === true) return;
    this._isAddOutcomeModalOpen = true;

    var modal = await this.modalController.create({
      component: AddOutcomeToSceneModalPage,
      id: '',
      componentProps: {
        "sceneId": scene.sceneId,
      }
    });

    modal.onDidDismiss().then(result => {
      this._isAddOutcomeModalOpen = false;
    });

    return await modal.present();
  }

  async openHelpModal(helpToDisplay) {

    if (this._isHelpModalOpen === true) return;
    this._isHelpModalOpen = true;

    const modal = await this.modalController.create({
      component: HelpModalPage,
      id: 'help-modal-' + helpToDisplay,
      componentProps: {
        "helpToDisplay": helpToDisplay
      }
    });

    modal.onDidDismiss().then(() => {
      this._isHelpModalOpen = false;
    });

    return await modal.present();
  }

  async openViewAssetModal(asset) {

    if (this._isViewAssetModalOpen === true) return;
    this._isViewAssetModalOpen = true;

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetTypeService.getType(asset.assetTypeId) + '-modal',
      componentProps: {
        "assetModalData": asset
      }
    });

    modal.onDidDismiss().then(() => {
      this._isViewAssetModalOpen = false;
    });

    return await modal.present();
  }

  async openViewTermsAndPoliciesModal() {

    if (this._isViewTermsAndConditionsModalOpen === true) return;
    this._isViewTermsAndConditionsModalOpen = true;

    return new Promise(async (resolve, reject) => {
      const viewTermsAndPoliciesModal = await this.modalController.create({
        component: ViewTermsAndPoliciesModalPage,
        id: 'terms-and-policies-modal',
        componentProps: {}
      });

      viewTermsAndPoliciesModal.onDidDismiss().then(result => {
        this._isViewTermsAndConditionsModalOpen = false;
        resolve(result.data);
      });

      await viewTermsAndPoliciesModal.present();
    });
  }

  async openViewOutcomeModal(outcome) {

    if (this._isViewOutcomeModalOpen === true) return;
    this._isViewOutcomeModalOpen = true;

    const modal = await this.modalController.create({
      component: ViewOutcomeModalPage,
      id: 'outcome-view-modal',
      componentProps: {
        "Outcome": outcome
      }
    });

    modal.onDidDismiss().then(() => {
      this._isViewOutcomeModalOpen = false;
    });

    return await modal.present();
  }

  async displayStorageModal() {

    if (this._isStorageModalOpen === true) return;
    this._isStorageModalOpen = true;

    const viewStorageModal = await this.modalController.create({
      id: 'view-storage-modal',
      component: ViewAssetStorageModalPage,
      componentProps: {
      }
    });

    viewStorageModal.onDidDismiss().then(result => {
      this.assetManagementService.getAssetsOnManagementPage();
      this._isStorageModalOpen = false;
    });

    return await viewStorageModal.present();
  }

  async displayProjectOutcomeManagementModal(project, outcomes) {

    if (this._isProjectOutcomeManagementOpen === true) return;
    this._isProjectOutcomeManagementOpen = true;

    var projectOutcomesRelationList = await this.ProjectOutcomeRelationService.getProjectOutcomeRelationByProjectId(project.projectId);
    let availableOutcomes = [] as Outcome[];
    if (projectOutcomesRelationList.length != 0) {
      let projectOutcomeRelationsOutcomeIds = projectOutcomesRelationList.map(x => { return x.outcomeId });
      availableOutcomes = outcomes.filter(y => projectOutcomeRelationsOutcomeIds.includes(y.outcomeId));
    }
    const viewStorageModal = await this.modalController.create({
      id: 'project-outcome-management-modal',
      component: ProjectOutcomeManagementPage,
      componentProps: {
        "project": project,
        "projectOutcomes": availableOutcomes,

      }
    });

    viewStorageModal.onDidDismiss().then(result => {
      this.assetManagementService.getAssetsOnManagementPage();
      this._isProjectOutcomeManagementOpen = false;
    });

    return await viewStorageModal.present();
  }

  removeOutcomeActions(enteredActions): Promise<void> {
    let i: number = 0;
    let length = enteredActions.length;
    return new Promise((resolve) => {
      enteredActions.forEach(action => {
        this.outcomeActionService.removeOutcomeAction(action.outcomeActionId).then(x => {
          i++;
          if (i == length) {
            resolve();
          }
        });
      });
    })

  }

  async presentSceneOutcomeActions(projectScene: Scene, projectId) {

    await this.outcomeActionService.getOutcomeActionBySceneId(projectScene.sceneId).then(async x => {
      if (projectScene.sceneIndex == 0) {
        var enteredActions = x.filter(x => x.outcomeActionTypeId == 9);
        if (enteredActions.length == 0) {
          projectScene.outcomeActions = x;
        }
        else {
          await this.removeOutcomeActions(enteredActions).then(async x => {
            await this.outcomeActionService.getOutcomeActionBySceneId(projectScene.sceneId).then(y => {
              projectScene.outcomeActions = y;
            })
          });

        }

      } else {
        projectScene.outcomeActions = x;
      }

      const displayOutcomeActionsModal = await this.modalController.create({
        id: 'outcome-actions-modal',
        component: OutcomeActionManagementModalPage,
        componentProps: {
          "scene": projectScene,
          "projectId": projectId,
          "outcomeActions": projectScene.outcomeActions
        }
      });

      displayOutcomeActionsModal.onDidDismiss().then(() => {

      });

      return await displayOutcomeActionsModal.present();
    });

  }

  async presentAssetOutcomeActions(projectId, assetInScene: AssetInScene) {

    if (this._isAssetOutcomeActionsModalOpen === true) return;
    this._isAssetOutcomeActionsModalOpen = true;

    await this.outcomeActionService.getOutcomeActionBySceneAssetRelationId(assetInScene.sceneAssetRelation.sceneAssetRelationId).then(async x => {

      assetInScene.outcomeActions = x;
      const displayOutcomeActionsModal = await this.modalController.create({
        id: 'outcome-actions-modal',
        component: OutcomeActionManagementModalPage,
        componentProps: {
          "asset": assetInScene,
          "projectId": projectId,
          "outcomeActions": assetInScene.outcomeActions
        }
      });

      displayOutcomeActionsModal.onDidDismiss().then(() => {
        this._isAssetOutcomeActionsModalOpen = false;
      });

      return await displayOutcomeActionsModal.present();
    });

  }

  presentSceneSettings(scene, editing, manageActions = false) {
    return new Promise<void>(async (resolve) => {
      if (this._isSceneSettingsModalOpen === true) return;
      this._isSceneSettingsModalOpen = true;
  
      const addOrEditSceneModal = await this.modalController.create({
        id: 'scene-settings-modal',
        component: SceneSettingsModalPage,
        componentProps: {
          "scene": this.deepCopyService.deepCopy(scene),
          "editing": editing,
          "displayActions": manageActions
        }
      });
  
      addOrEditSceneModal.onDidDismiss().then(() => {
        this._isSceneSettingsModalOpen = false;
        resolve();
      });
  
      await addOrEditSceneModal.present();
    });

  }

  presentExportProjectWizard(project: Project): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {

      if (this._isExportProjectWizardModalOpen === true) return;
      this._isExportProjectWizardModalOpen = true;
  
      await this.messagesService.presentLoadingWindow('Validating Distribution and Reporting credits...');
      let lrsCredits: number = await this.customerUsageService.getLRSCreditsUsagePercentage();
      let streamingCredits: number = await this.customerUsageService.getStreamingCreditsUsagePercentage();
      await this.messagesService.loadingWindow.dismiss();
  
      if (lrsCredits >= 80 || streamingCredits >= 80) {
        let confirmationResult = await this.confirmationExportProject(lrsCredits, streamingCredits);
        if (confirmationResult === 'buy') {
          if (this.cryptoService.decryptData(this.storageService.getItem("login_r")) == "ad") {
            this._isExportProjectWizardModalOpen = false;
            this.router.navigateByUrl('/my-account');
            resolve(false);
          }
          else {
            this._isExportProjectWizardModalOpen = false;
            this.router.navigateByUrl('/contact-admin');
            resolve(false);
          }
          return;
        }
      }
  
      const exportProjectWizardModal = await this.modalController.create({
        id: 'export-project-wizard-modal',
        component: ExportProjectWizardModalPage,
        componentProps: {
          "project": project
        }
      });
  
      exportProjectWizardModal.onDidDismiss().then(() => {
        this._isExportProjectWizardModalOpen = false;
        resolve(true);
      });
  
      await exportProjectWizardModal.present();
    });
  }

  confirmationExportProject(lrsCreditsRemaining: number, streamingCreditsRemaining: number): Promise<string> {
    return new Promise<string>(async (resolve) => {
      let message: string = '';
      if (lrsCreditsRemaining >= 80 && lrsCreditsRemaining < 100 && streamingCreditsRemaining >= 80 && streamingCreditsRemaining < 100) {
        message = 'Your distribution and reporting credits are running low. Do you want to buy more credits?';
      } else if (lrsCreditsRemaining >= 80 && lrsCreditsRemaining < 100) {
        message = 'Your reporting credits is running low. Do you want to buy more reporting credits?';
      } else if (streamingCreditsRemaining >= 80 && streamingCreditsRemaining < 100) {
        message = 'Your distribution credits is running low. Do you want to buy more distribution credits?';
      } else if (lrsCreditsRemaining >= 100 && streamingCreditsRemaining >= 100) {
        message = `You have used all your distribution and reporting credits. Do you want to buy more credits?`;
      } else if (lrsCreditsRemaining >= 100) {
        message = `You have used all your reporting credits. Do you want to buy more reporting credits?`;
      } else if (streamingCreditsRemaining >= 100) {
        message = `You have used all your distribution credits. Do you want to buy more distribution credits?`;
      }

      const alert = await this.alertController.create({
        header: 'Export Project',
        message: message,
        cssClass: 'leave-alert',
        backdropDismiss: false,
        buttons: [{
          text: 'Go To Account Page',
          cssClass: 'leave-button',
          handler: () => {
            resolve('buy');
          }
        }, {
          text: 'Continue',
          cssClass: 'leave-button',
          handler: () => {
            resolve("continue");
          }
        }
        ]
      });
      await alert.present();
    });
  }
}
